import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import styles from './ToastsContainer.module.scss';
import Toast from '../Toast/Toast';
const ToastsContainer = () => {
    const toasts = useSelector((state) => state.success.items);
    if (!toasts.length)
        return null;
    return ReactDOM.createPortal(_jsx("div", Object.assign({ className: styles.toasts__container, "data-testid": "toast-container" }, { children: toasts.map((toast) => (_jsx(Toast, Object.assign({}, toast), toast.id))) })), document.body);
};
export default ToastsContainer;
